<template>
  <div>
    <div
      :class="['card-wrap border-ce5 clearfix prelative', orderInfo.style]"
      :style="showAddressNotice && { 'padding-bottom': '10px' }"
    >
      <img :src="orderInfo.headImg" alt="upaid" class="fl img" />
      <div class="fl mt-32">
        <div style="display: flex; align-items: center">
          <div>
            <h1 class="text-c111 font-s20 dib mr-24">
              {{ TLang(orderInfo.title, "list") }}
              <span
                class="status-text"
                v-if="
                  ([3, 4, 6].indexOf(orderInfo.orderStatus) <= -1 ||
                    ([3, 4, 6].indexOf(orderInfo.orderStatus) > -1 &&
                      orderInfo.auditStatus !== 'audit')) &&
                  orderInfo.auditStatusText
                "
                :style="
                  'padding:0px 4px;border-radius: 9px;color:' +
                  applyStatus[orderInfo.auditStatus] +
                  ';background:' +
                  applyStatusBg[orderInfo.auditStatus]
                "
              >
                {{ orderInfo.auditStatusText }}</span
              >
            </h1>
            <span v-if="orderInfo.orderStatus === 1" class="mr-4">
              <img
                :src="require('@assets/images/order/timer-icon.png')"
                style="width: 14px; position: relative; top: -2px"
              />
            </span>

            <span
              class="text-c666 mr-8"
              v-if="
                orderInfo.auditStatus === 'audit' &&
                [3, 4, 6].indexOf(orderInfo.orderStatus) <= -1
              "
              >{{ TLang("审核剩余时间", "paypending") }}</span
            >
            <!-- <span class="text-c666 mr-8" v-else>{{
            orderInfo.orderSubStatusDesc ||
            TLang(orderInfo.description, "order")
          }}</span> -->
            <span
              v-if="
                orderInfo.auditStatus === 'audit' &&
                [3, 4, 6].indexOf(orderInfo.orderStatus) <= -1
              "
              class="text-num-red"
              >{{ showAuditTime }}</span
            >
            <span
              class="text-c666 mr-8"
              v-if="
                orderInfo.orderStatus === 1 && orderInfo.auditStatus !== 'audit'
              "
              >{{ TLang("支付剩余时间", "paypending") }}</span
            >
            <span
              v-if="
                orderInfo.orderStatus === 1 && orderInfo.auditStatus !== 'audit'
              "
              class="text-num-red"
              >{{ countDownTimer }}</span
            >
          </div>
          <div
            class="show-tips"
            :title="orderInfo.logisticPrompt"
            v-if="orderInfo.logisticPrompt"
          >
            <img src="./imgs/tips.png" /><marquee
              scrollamount="7"
              style="width: calc(100% - 40px)"
              >{{ orderInfo.logisticPrompt }}</marquee
            >
          </div>
        </div>
        <div class="status-desc" v-if="orderInfo.orderSubStatusDesc">
          {{ TLang("原因", "paypending") }}: {{ orderInfo.orderSubStatusDesc }}
        </div>
        <div class="mt-24">
          <div class="mb-8">
            <div v-if="orderInfo.postcode">
              <label class="text-c999">{{ TLang("邮编", "list") }}</label>
              <span class="text-num">{{ orderInfo.postcode }}</span>
            </div>
            <label class="text-c999">{{ TLang("订单编号", "list") }}</label>
            <span class="text-num">{{ orderInfo.orderNo }}</span>
            <label class="text-c999 ml-32"
              >{{ TLang("下单时间", "list") }}：</label
            >
            <span class="text-num">{{ orderInfo.creationTime }}</span>
            <label
              class="text-c999 ml-32"
              v-if="
                orderInfo.auditAt &&
                (orderInfo.auditStatus === 'pass' ||
                  orderInfo.auditStatus === 'rejected')
              "
              >{{ TLang("审核时间", "list") }}：</label
            >
            <span
              class="text-num"
              v-if="
                orderInfo.auditStatus === 'pass' ||
                orderInfo.auditStatus === 'rejected'
              "
              >{{ orderInfo.auditAt }}</span
            >
          </div>
          <div class="clearfix" style="line-height: 21px">
            <label class="text-c999 fl" style="line-height: 21px"
              >{{ TLang("收货信息", "orderConfirm") }}：</label
            >
            <span class="text address-max-width line-clamp-1 fl">
              {{ orderInfo.recvName }}
              <em class="font-num">{{ orderInfo.recvMobile }}</em>
              {{ orderInfo.recvAddr }}
            </span>
            <span
              v-if="isModifyAddress"
              class="font-s12 font-blue fl ml-32 pointer"
              @click="this.changeAddressListStatus"
              >{{ TLang("修改", "address") }} ></span
            >
          </div>
          <!-- <div
            v-if="showAddressNotice"
            class="notice"
          >
            <img
              :src="require('@assets/images/order/notice.png')"
              alt=""
            >
            <span>您的收货地址仅支持同城区及详细地址的修改！</span>
          </div> -->
        </div>
      </div>
      <div
        v-if="orderInfo.orderStatus === 1"
        class="fr mt-36 mr-36"
        style="position: relative"
      >
        <!-- <el-tooltip
          v-if="orderInfo.auditStatus === 'audit'"
          class="item"
          effect="dark"
          :content="TLang('请在订单审核通过后完成支付', 'paypending')"
          placement="bottom-end"
        > -->
        <div
          v-if="orderInfo.auditStatus === 'audit'"
          class="btn-theme-w108"
          :style="'opacity: 0.5'"
          @mouseenter="auditStatusShow = true"
          @mouseleave="auditStatusShow = false"
        >
          {{ TLang("继续支付", "list") }}
        </div>
        <!-- </el-tooltip> -->
        <div
          v-if="orderInfo.auditStatus != 'audit'"
          class="btn-theme-w108"
          :style="'opacity: 1'"
          @click="onNavigatorToPay"
        >
          {{ TLang("继续支付", "list") }}
        </div>
        <div
          v-if="auditStatusShow"
          class="tips-audit"
          @click="auditStatusShow = false"
        >
          {{ TLang("请在订单审核通过后完成支付", "paypending") }}
        </div>
        <div
          class="btn-default-w108 mt-16"
          @click="confirmDialog = !confirmDialog"
        >
          {{ TLang("取消订单", "list") }}
        </div>
      </div>
      <div v-if="orderInfo.delete" class="fr mt-36 mr-36">
        <div
          class="btn-default-w108"
          @click="delModalVisible = !delModalVisible"
        >
          {{ TLang("删除订单", "my") }}
        </div>
      </div>
      <div v-if="orderInfo.orderAllRefund" class="fr mt-36 mr-36">
        <div
          class="btn-theme-w108"
          @click="orderRefundDialog = !orderRefundDialog"
        >
          {{ TLang("申请退款", "list") }}
        </div>
      </div>
    </div>
    <confirm-dialog
      :img="require('@assets/images/order.png')"
      :title="TLang('您确认要取消该订单吗', 'my')"
      :confirmBtnText="TLang('确认取消', 'orderConfirm')"
      :cancelBtnText="TLang('暂不取消', 'orderConfirm')"
      @onCancelDialog="closeDialog"
      @onConfirmDialog="onDeleteOrder"
    ></confirm-dialog>
    <el-dialog
      :visible.sync="orderRefundDialog"
      width="30%"
      :show-close="false"
      :center="true"
      top="50vh"
      custom-class="refund-modal"
    >
      <div class="refund-modal_wrap">
        <!-- <img src="@assets/images/order/order_del.png" alt="" /> -->
        <h2>{{ title }}</h2>
        <div class="bottom-btn-wrap">
          <div class="close-btn" @click="orderRefundDialog = false">
            {{ TLang("再想想", "address") }}
          </div>
          <div class="confirm-btn" @click="onCancelDelivery">
            {{ TLang("确认", "address") }}
          </div>
        </div>
      </div>
      <div class="close-icon" @click="orderRefundDialog = false">
        <img src="@assets/images/order/order_close.png" alt="" />
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="delModalVisible"
      width="30%"
      :show-close="false"
      :center="true"
      top="50vh"
      custom-class="del-modal"
    >
      <div class="del-modal_wrap">
        <img src="@assets/images/order/order_del.png" alt="" />
        <h2>{{ TLang("删除订单", "my") }}</h2>
        <p>{{ TLang("删除后将无法找回订单", "my") }}</p>
        <div class="bottom-btn-wrap">
          <div class="close-btn" @click="delModalVisible = false">
            {{ TLang("再想想", "my") }}
          </div>
          <div class="confirm-btn" @click="confirmDelOrder">
            {{ TLang("删除订单", "my") }}
          </div>
        </div>
      </div>
      <div class="close-icon" @click="delModalVisible = false">
        <img src="@assets/images/order/order_close.png" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "@components/confirmDialog";
import { deleteOrder, getPayUrl } from "@fetch/order";
import { doValidate } from '@fetch/index';
import Toast from "@components/simpleToast";
import { mapActions, mapState } from "vuex";
import { unionFlag } from "@utils";
const PAGE = {
  orderListFlag: false,
};
export default {
  name: "OrderCard",
  components: {
    ConfirmDialog,
  },
  props: {
    orderInfo: Object,
    showAddressNotice: Boolean,
    isModifyAddress: Boolean,
  },
  created() {
    doValidate().then(res => {
      if (res.code === 200) {
        PAGE.orderListFlag = res.data;
      };
    });
  },
  data() {
    return {
      confirmDialog: false,
      countDownTimer: "",
      showAuditTime: "",
      delModalVisible: false,
      auditStatusShow: false,
      // 审批状态
      applyStatus: {
        audit: "#FF6600",
        pass: "#00B87A",
        rejected: "#F44545",
        timeout: "#F44545",
      },
      applyStatusBg: {
        audit: "#FFF7F2",
        pass: "#F2FBF8",
        rejected: "#FEF5F5",
        timeout: "#FEF5F5",
      },
      orderRefundDialog: false,
      title: this.TLang("您要申请退款吗", "orderConfirm"),
    };
  },
  watch: {
    orderInfo(val) {
      if (val.auditStatus === "audit") {
        this.countDown2(new Date(val.auditTimeoutAt));
      } else {
        val.payLeftTime && this.countDown(val.payLeftTime);
      }
    },
  },
  methods: {
    ...mapActions("orderDetail", ["cancelDelivery"]),
    onNavigatorToPay() {
      if (this.orderInfo.auditStatus === "audit") {
        this.auditStatusShow = !this.auditStatusShow;
        return;
      }
      // const union = unionFlag() || sessionStorage.getItem('dffl_union');
      const params = {
        orderNo: this.orderInfo.orderNo,
        terminalType: "PC",
        // returnUrls:{
        //   returnMechantUrl:encodeURIComponent(`${location.origin}/shop/home`),
        //   returnOrderListUrl:encodeURIComponent(`${location.origin}/shop/order/list`),
        //   returnOrderDetailUrl:encodeURIComponent(`${location.origin}/shop/order/detail/${this.orderInfo.orderNo}`)
        // }
      };
      // if(union){
      //   window.location.href = this.orderInfo.payUrl;
      //   return;
      // }
      getPayUrl(params).then((res) => {
        if (res && res.url) {
          window.location.href = res.url;
        } else {
          setTimeout(() => {
            this.$parent.getOrderDetailInfo &&
              this.$parent.getOrderDetailInfo({
                orderNo: this.orderInfo.orderNo,
              });
          }, 1000);
        }
      });
    },
    changeAddressListStatus() {
      this.$parent.addressListDialog = true;
    },
    countDown(timer) {
      // const timer = 6892194;
      let count = parseInt(timer / 1000);
      let clearTimer = setInterval(() => {
        if (!count) {
          clearInterval(clearTimer);
          this.$parent.fetchOrderInfo();
        }

        //天数
        const days = parseInt(count / 3600 / 24);
        
        //小时
        const hours = parseInt(count / 3600);
        
        //分钟
        const minutes = parseInt((count / 60) % 60);
        
        //秒
        const seconds = parseInt(count % 60);

        // 原计算方式，小时计算有问题
        // const minute =
        //   count > 0
        //     ? parseInt(count / 60) > 9
        //       ? parseInt(count / 60)
        //       : "0" + parseInt(count / 60)
        //     : "00";
        // const second =
        //   count > 0
        //     ? parseInt(count % 60) > 9
        //       ? parseInt(count % 60)
        //       : "0" + parseInt(count % 60)
        //     : "00";
        // const hour =
        //   minute / 60 > 1
        //     ? minute / 60 > 9
        //       ? minute / 60
        //       : `0${minute / 60}`
        //     : "";

        // this.countDownTimer =
        //   (hour !== "" ? hour + ":" : "") + minute + ":" + second;
        this.countDownTimer = (days > 0 ? days + "天 " : "") +
          (hours > 0 ? "0" + hours + ":" : "") + (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds);
        count--;
      }, 999);
    },
    countDown2(timer) {
      if (!timer) {
        return;
      }
      const _time = timer - new Date();
      let count = parseInt(_time / 1000);
      var clearInterval = window.setInterval(() => {

        if (count <= 0) {
          window.clearInterval(clearInterval);
          this.$emit("cb");
          return;
        }
        let hh = count > 0 ? parseInt(count / 60 /60) : "00";
        let mm = count > 0 ? parseInt((count / 60) %60) : "00";
        let ss = count > 0 ? parseInt(count % 60) : "00";
        hh = hh < 10  ? '0' + hh : hh;
        mm = mm < 10  ? '0' + mm : mm;
        ss = ss < 10  ? '0' + ss : ss;
        this.showAuditTime = hh + ':' + mm + ':' + ss;
        count--;
      }, 1000);
    },
    closeDialog() {
      this.confirmDialog = !this.confirmDialog;
    },
    onDeleteOrder() {
      const { orderNo } = this.orderInfo;
      this.$store.dispatch("orderDetail/onCancelOrder", {
        orderNo,
        deliveryOrderCancelRemark: this.TLang("取消订单", "list"),
        cancelAll: true,
        success: () => {
          this.closeDialog();
          this.$parent.initData();
          this.$message.success(this.TLang("订单已取消", "orderConfirm"));
        },
        error: () => this.closeDialog(),
      });
    },
    confirmDelOrder() {
      deleteOrder({ orderNo: this.orderInfo.orderNo }).then((res) => {
        if (res) {
          this.$message.success(this.TLang("订单已删除", "orderConfirm"));
          setTimeout(() => {
            const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
            if (unionF && unionF !== 'null') {
              window.location.href = "/shop/order/list";
            } else {
              if (PAGE.orderListFlag) {
                window.location.href = window.location.origin + '/unitedorder';
              } else {
                window.location.href = "/shop/order/list";
              }
            }
          }, 1000);
        }
      });
      this.delModalVisible = false;
    },
    onCancelDelivery() {
      // http://showdoc.psf-dev.com/web/#/1?page_id=1490
      this.cancelDelivery({
        orderNo: this.orderInfo.orderNo,
        deliveryOrderCancelRemark: this.TLang("用户端取消", "orderConfirm"),
        cancelAll: true,
        isPhP: false,
      })
        .then((res) => {
          if (res && res.msg) {
            this.orderRefundDialog = !this.orderRefundDialog;
            Toast.info(res.msg, 1.5);
            this.$parent.initData();
          }
        })
        .catch((err) => {
          this.orderRefundDialog = !this.orderRefundDialog;
          Toast.info(err, 1);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.show-tips {
  width: 220px;
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
  border: 1px solid #ff6600;
  background-color: #fff7eb;
  font-size: 12px;
  font-weight: 400;
  color: #ff6600;
  & > img {
    vertical-align: baseline;
    height: 40px;
  }
}
.card-wrap {
  padding-bottom: 26px;
  padding-left: 196px;

  .address-max-width {
    max-width: 700px;
  }

  .img {
    position: absolute;
    top: 28px;
    left: 32px;
    width: 123px;
    height: 105px;
  }

  .notice {
    display: inline-block;
    margin-top: 10px;
    padding: 8px;
    background: #fdecec;
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #f44545;
    box-shadow: 0px 1px 2px 0px rgba(212, 98, 98, 0.2);
    position: relative;

    &::before {
      content: "";
      border: solid 4px;
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: #fdecec;
      position: absolute;
      top: -8px;
      left: 28px;
    }

    img {
      width: 12px;
      height: 13px;
      vertical-align: middle;
    }
  }
}
.status-text {
  height: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-left: 9px;
}
.status-desc {
  margin-top: 10px;
  font-size: 14px;
  color: #666666;
  max-width: 535px;
}
.tips-audit {
  width: 201px;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  right: 0px;
  margin-top: 8px;
  max-height: 41px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 19px;
  padding: 10px 8px;
  border-radius: 4px;
}
.tips-audit::before {
  content: "";
  position: absolute;
  width: 0px;
  height: 0px;
  top: -14px;
  right: 45px;
  border-top: 7px solid transparent;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(0, 0, 0, 0.8);
}
</style>
<style lang="less">
.del-modal {
  transform: translateY(-60%);
  padding-bottom: 22px;
  .el-dialog__header {
    padding: 0 !important;
  }
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .el-dialog__header {
    display: none;
  }
  .del-modal_wrap {
    text-align: center;
    .bottom-btn-wrap {
      display: flex;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      text-align: center;
      line-height: 40px;
      justify-content: center;
      margin-top: 28px;
      margin-bottom: 22px;
      .close-btn {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        color: #fff;
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
        font-weight: bold;
      }
      .confirm-btn {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid rgba(229, 229, 229, 1);
        margin-left: 30px;
      }
    }
    img {
      width: 62px;
      height: 56px;
      margin-top: 14px;
    }
    h2 {
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(51, 51, 51, 1);
      line-height: 44px;
    }
    p {
      font-size: 14px;
      font-family: MicrosoftYaHeiLight;
      color: rgba(102, 102, 102, 1);
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.refund-modal {
  transform: translateY(-60%);
  // padding-bottom: 22px;
  .el-dialog__header {
    padding: 0 !important;
  }
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .el-dialog__header {
    display: none;
  }
  .refund-modal_wrap {
    text-align: center;
    .bottom-btn-wrap {
      display: flex;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      text-align: center;
      line-height: 40px;
      justify-content: center;
      margin-top: 28px;
      margin-bottom: 22px;
      .close-btn {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        color: #fff;
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
        font-weight: bold;
      }
      .confirm-btn {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid rgba(229, 229, 229, 1);
        margin-left: 30px;
      }
    }
    img {
      width: 62px;
      height: 56px;
      margin-top: 14px;
    }
    h2 {
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(51, 51, 51, 1);
      line-height: 44px;
    }
    p {
      font-size: 14px;
      font-family: MicrosoftYaHeiLight;
      color: rgba(102, 102, 102, 1);
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.goods-img-wrap {
  position: relative;
}
</style>
